import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Position {
  id?: string
  name: string
  code: string
  country_id: string
}

export async function getPositions(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id = :countryId']
  if (search) {
    where.push(`CONCAT(name,code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_positions'],
    fields: ['id', 'code', 'name', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getPosition(id: string): Promise<Position> {
  const data = await getData<any>({
    tables: ['pg_positions'],
    fields: ['id', 'name', 'code', 'country_id', 'custom_fields as custom'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createPosition(data: Position): Promise<boolean> {
  const response: any = await http.post('country/positions', {
    countryId: data.country_id,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updatePosition(
  data: Position,
  id: string
): Promise<boolean> {
  const response: any = await http.put('country/positions/' + id, {
    countryId: data.country_id,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deletePosition(id: string): Promise<boolean> {
  const response: any = await http.delete('country/positions/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
